
import paginationAccessibility from '../../../../themes/ae/assets/js/modules/classes/paginationAccessibility.js';

export default class eventList
{
    constructor()
    {
        this.el = '#eventList';

        if (!$(this.el).length) {
            return;
        }

        this.data = {
            events: {},
            eventType: 'All',
            pagination: {
                perPage: 4,
                numPages: 0,
                currentPage: 1,
                accessibility: null,
            },
            settings: {
                ariaMessage: '',
                previousAriaMessage: '',
            },
            fetchEventsPath: fetchResults
        };

        this._initVue();
    }

    _initVue()
    {
        let eventListVue = new Vue({
            el: this.el,
            data: this.data,
            computed: {
                eventRows() {
                    let eventRows = {};
                    let eventRow = [];

                    Object.keys(this.events).forEach(index => {
                        // the index is a string for some amazing javascript reason
                        index = Number(index);
                        eventRow.push(this.events[index]);

                        if (!((index + 1) % 2)) {
                            eventRows[Object.keys(eventRows).length] = eventRow;
                            eventRow = [];
                        } else if ((index + 1) === Object.keys(this.events).length) {
                            eventRows[Object.keys(eventRows).length] = eventRow;
                        }
                    });

                    return eventRows;
                },
            },
            methods: {
                formatDateBlock(date, isMonth = true) {
                    let m = moment(date, 'MMMM D, YYYY');

                    return isMonth ? m.format('MMM', date) : m.format('D', date);
                },

                fetchListing() {
                    this.settings.previousAriaMessage = this.settings.ariaMessage;
                    this.settings.ariaMessage = '';

                    axios.post(this.fetchEventsPath, {
                        perPage: this.pagination.perPage,
                        currentPage: this.pagination.currentPage,
                        eventType: this.eventType,
                    }).then(response => {
                        this.events = response.data.results.results;
                        this.pagination.numPages = response.data.results.totalPages;
                        this.pagination.currentPage = response.data.results.currentPage;
                        this.pagination.accessibility.setAriaLabels();

                        let results = this.events.length === 1 ? 'result' : 'results';
                        if (this.settings.previousAriaMessage === this.events.length + ' ' + results + ' returned') {
                            this.settings.ariaMessage = 'Returned ' + this.events.length + ' ' + results;
                        } else {
                            this.settings.ariaMessage = this.events.length + ' ' + results + ' returned';
                        }

                    }).catch(err => {
                        console.error(err);
                    });
                },

                pageChange() {
                    this.fetchListing();
                },
            },
            beforeMount() {
                this.pagination.accessibility = new paginationAccessibility();
                this.fetchListing();
            }
        });
    }
}
